/* eslint-disable react-hooks/exhaustive-deps */

import { EditIcon, IconWrapper, Link, LinkSize } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { PreInterviewUpdateModalOpener } from '../../../preInterview/update/PreInterviewUpdateModal.opener';

type PreInterviewUpdateLinkProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientFullName: string;
   readonly surveyId: number;
};

export const PreInterviewUpdateLink = (props: PreInterviewUpdateLinkProps): JSX.Element => {
   return (
      <PreInterviewUpdateModalOpener
         appointmentId={props.appointmentId}
         beginDate={props.beginDate}
         endDate={props.endDate}
         patientFullName={props.patientFullName}
         surveyId={props.surveyId}
      >
         {({ openModal }) => (
            <Link
               testId={'updatePreInterview'}
               label={appointmentsTranslationKeys.preInterview.table.column.actions.update}
               size={LinkSize.NORMAL}
               onClick={openModal}
               icon={
                  <IconWrapper testId={'updateIcon'}>
                     <EditIcon />
                  </IconWrapper>
               }
            />
         )}
      </PreInterviewUpdateModalOpener>
   );
};
